import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {
    fontSize: 18,
    color: custom.grey[2],
    margin: 0,
    padding: '20px 0',
  },
}));
